'use strict';

exports.__esModule = true;
var RESIZE_FIT = exports.RESIZE_FIT = 'resize-fit';
var RESIZE_COVER = exports.RESIZE_COVER = 'resize-cover';
var RENDER_PLACEHOLDER = exports.RENDER_PLACEHOLDER = 'render-placeholder';
var RENDER_IMAGE = exports.RENDER_IMAGE = 'render-image';
var RENDER_IMAGE_WITH_PLACEHOLDER = exports.RENDER_IMAGE_WITH_PLACEHOLDER = 'render-image-with-placeholder';
var RENDER_IMAGE_WITH_PLACEHOLDER_INITIALLY = exports.RENDER_IMAGE_WITH_PLACEHOLDER_INITIALLY = 'render-image-with-placeholder-initially';